export function isValidJson(json: string) {
  try {
    return typeof JSON.parse(json) === 'object';
  } catch (_e) {
    return false;
  }
}